import React, { useEffect, useState } from "react";
import "./FunooniNFTs.scss";
import Step from "./Step";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { useWallet } from "../../../contexts/WalletContext";

const FunooniNFTs = ({
  mainTitle = "Get Started with Funooni NFTs",
  mainDescription = "Unlock the world of exclusive digital art with Funooni NFTs! Follow these simple steps to dive in and start your journey:",
  connectBtnText = "Connect Wallet",
  loginBtnText = "Log-in",
  optionalTitle = "OPTIONAL",

  data = {},
  steps = [],
  optionalList = [],
}) => {
  const [artItem, setArtItem] = useState({});
  const navigate = useNavigate();

  const { ethAddress: authEthAddress, userEmail } = useAuth();
  const {
    ethAddress: walletAddress,
    isConnecting,
    connectWallet,
  } = useWallet();

  useEffect(() => {
    if (data) setArtItem(data);
  }, [data]);

  const displayInfo = walletAddress || authEthAddress;

  const handleLoginClick = () => {
    navigate("/auth");
  };

  const handleWalletConnection = async () => {
    try {
      await connectWallet("MetaMask");
    } catch (error) {
      console.error("Failed to connect wallet:", error);
    }
  };

  const formatAddress = (address) => {
    return `${address.substring(0, 6)}....${address.substring(
      address.length - 4
    )}`;
  };

  return (
    <div className="funooni-container">
      <div className="funooni-header">
        <h2>{mainTitle}</h2>
        <p>{mainDescription}</p>

        <div className="buttons">
          {displayInfo ? (
            <div className="wallet-address">
              {walletAddress ? (
                <div className="wallet-display">
                  <span>{formatAddress(walletAddress)}</span>
                </div>
              ) : (
                <span>{formatAddress(displayInfo)}</span>
              )}
            </div>
          ) : (
            <>
              <button
                className="connect-wallet"
                onClick={handleWalletConnection}
                disabled={isConnecting}
              >
                {isConnecting ? "Connecting..." : connectBtnText}
              </button>

              {!userEmail && (
                <>
                  <span>or</span>
                  <button className="login" onClick={handleLoginClick}>
                    {loginBtnText}
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>

      <div className="funooni_content">
        <div className="funooni-steps">
          {steps.map((step, index) => (
            <Step
              key={index}
              image={step.image}
              title={step.title}
              content={step.content}
              link={step.link}
              list={step.list}
            />
          ))}
        </div>

        <div className="optional-section">
          <div className="optional-box optional">
            <h2>{optionalTitle}</h2>
          </div>

          {optionalList.map((info, index) => (
            <div key={index} className="optional-box">
              <h3>{info.title}</h3>
              <p>{info.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FunooniNFTs;